import React from 'react';
import { useTheme } from 'hooks';

interface CheckboxPropTypes {
  width?: string;
  height?: string;
  checked?: boolean;
  fill?: string;
}

export const Checkbox: React.FC<CheckboxPropTypes> = ({ width, height, checked, fill }) =>
  checked
    ? <CheckedCheckbox width={width} height={height} fill={fill} />
    : <UncheckedCheckbox width={width} height={height} fill={fill} />;

Checkbox.defaultProps = {
  width: '1.125rem',
  height: '1.125rem',
  checked: false,
  fill: 'white'
};

interface CheckedCheckboxPropTypes extends Omit<CheckboxPropTypes, 'checked'> {}
const CheckedCheckbox: React.FC<CheckedCheckboxPropTypes> = ({ width, height, fill }) => {
  const { styles: { colorPrimaryButtonBackground } } = useTheme();

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="17" height="17" rx="0.5" fill={colorPrimaryButtonBackground} stroke={colorPrimaryButtonBackground} />
      <rect x="1.5" y="1.5" width="15" height="15" rx="0.5" stroke={fill} />
    </svg>
  );
};

interface UncheckedCheckboxPropTypes extends Omit<CheckboxPropTypes, 'checked'> {}
const UncheckedCheckbox: React.FC<UncheckedCheckboxPropTypes> = ({ width, height, fill }) => {
  const { styles: { colorPrimaryButtonBackground } } = useTheme();

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="17" height="17" rx="0.5" fill={fill} stroke={colorPrimaryButtonBackground} />
    </svg>
  );
};
